import { render } from "./swiper.vue?vue&type=template&id=25308a8b&scoped=true&ts=true"
import script from "./swiper.vue?vue&type=script&lang=ts"
export * from "./swiper.vue?vue&type=script&lang=ts"

import "./swiper.vue?vue&type=style&index=0&id=25308a8b&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/www.soyoung.com-vue3-pc-master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25308a8b"]])

export default __exports__